(ns frontend.ui.component.lp-portal.voima-components.badge.view
  (:require
   [frontend.ui.component.lp-portal.voima-components.badge.style :as style]
   [herb.core :refer [<class]]))

(defn badge
  [props child]
  [:span
   (merge {:class (<class style/badge props)}
          (select-keys props [:on-click]))
   child])
